interface IObjectInspectorIconProps {
  className?: string;
}

/**
 * Atom. The tool's mental model is "one primary row at the center, related
 * rows orbiting on tenancy paths" — which is exactly what an atom diagram
 * shows: a nucleus surrounded by three orbital paths carrying electrons.
 * Monoline, `currentColor`, no fills except the nucleus + electrons (filled
 * to read clearly at tile size). Designed on a 48×48 grid to match the rest
 * of the home tile set.
 */
const ObjectInspectorIcon = ({ className }: IObjectInspectorIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* Three elliptical orbits rotated 0° / 60° / 120° around the center.
        rx/ry control the ellipse's flatness; the rotation gives the
        characteristic three-lobed atom silhouette. */}
    <ellipse cx="24" cy="24" rx="18" ry="7" />
    <ellipse cx="24" cy="24" rx="18" ry="7" transform="rotate(60 24 24)" />
    <ellipse cx="24" cy="24" rx="18" ry="7" transform="rotate(120 24 24)" />
    {/* Nucleus — the "primary" row at the dead center of the inspector view. */}
    <circle cx="24" cy="24" r="2.5" fill="currentColor" stroke="none" />
    {/* Three electrons — one on each orbit, parked at distinct phase angles
        so they read as individually orbiting bodies rather than mirror-image
        pairs. Each sits on the orbit's far edge (rx = 18 from center). */}
    <circle cx="42" cy="24" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="15" cy="8.4" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="15" cy="39.6" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

export default ObjectInspectorIcon;
